// YTI-1732 : un virement sortant porte l'un de ces deux libellés. « Virement »
// est le mode saisi ; « Virement Bridge » est posé par le serveur quand un
// payment request Bridge est rattaché au mouvement, et rendu à « Virement »
// si l'initiation est libérée. Un mouvement refusé par la banque garde le
// second libellé et doit rester réinitiable.
export const TRANSFER_PAYMENT_MODE = "Virement";
export const BRIDGE_TRANSFER_PAYMENT_MODE = "Virement Bridge";

export const isTransferPaymentMode = (mode: string | null | undefined): boolean =>
  mode === TRANSFER_PAYMENT_MODE || mode === BRIDGE_TRANSFER_PAYMENT_MODE;

// Une remise SEPA regroupée crée un mouvement « Remise de virements » et vide
// les virements d'origine (0 €, verrouillés), qui gardent ce mode et la
// référence SEPARM de la remise : montant et écritures sont sur la remise.
export const SEPA_REMITTANCE_PAYMENT_MODE = "Remise de virements";
export const ARCHIVED_SEPA_TRANSFER_PAYMENT_MODE = "Remise de virements (archivé)";

export const isArchivedSepaTransfer = (mode: string | null | undefined): boolean =>
  mode === ARCHIVED_SEPA_TRANSFER_PAYMENT_MODE;
